export default __webpack_public_path__ + "static/media/1926.390e4221.png";